import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as businessApi from "@/services/businessApi";

export const businessKeys = {
  all: ["business-accounts"] as const,
  list: () => [...businessKeys.all, "list"] as const,
};

export function useBusinessAccounts() {
  return useQuery({
    queryKey: businessKeys.list(),
    queryFn: businessApi.listBusinessAccounts,
  });
}

export function useCreateBusinessAccount() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: businessApi.createBusinessAccount,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: businessKeys.all });
    },
  });
}

export function usePatchBusinessAccount() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      businessId,
      ...patch
    }: { businessId: number } & businessApi.PatchBusinessAccountRequest) =>
      businessApi.patchBusinessAccount(businessId, patch),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: businessKeys.all });
    },
  });
}

export function useResendBusinessAccountInvite() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => businessApi.resendBusinessAccountInvite(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: businessKeys.all });
    },
  });
}

export function useDeleteBusinessAccount() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => businessApi.deleteBusinessAccount(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: businessKeys.all });
    },
  });
}
